import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ProfilePage = lazy(() => import('../pages/dashboard/profile/page'));
const SettingsPage = lazy(() => import('../pages/dashboard/settings/page'));
const NotificationsPage = lazy(() => import('../pages/dashboard/notifications/page'));
const MessagesPage = lazy(() => import('../pages/dashboard/messages/page'));
const CandidatePublicProfile = lazy(() => import('../pages/candidate/[id]/page'));
const JobDetailPage = lazy(() => import('../pages/job/[id]/page'));
const HelpCenterPage = lazy(() => import('../pages/help-center/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/[slug]/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const CareerResourcesPage = lazy(() => import('../pages/career-resources/page'));
const CompanyPublicProfile = lazy(() => import('../pages/company/[id]/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/dashboard/profile',
    element: <ProfilePage />,
  },
  {
    path: '/dashboard/settings',
    element: <SettingsPage />,
  },
  {
    path: '/dashboard/notifications',
    element: <NotificationsPage />,
  },
  {
    path: '/dashboard/messages',
    element: <MessagesPage />,
  },
  {
    path: '/candidate/:id',
    element: <CandidatePublicProfile />,
  },
  {
    path: '/company/:id',
    element: <CompanyPublicProfile />,
  },
  {
    path: '/job/:id',
    element: <JobDetailPage />,
  },
  {
    path: '/help-center',
    element: <HelpCenterPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/career-resources',
    element: <CareerResourcesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
